import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Configuracoes } from 'src/app/entities/configuracoes';
import { PedidoService } from 'src/app/services/pedido-service';
import { InitProvider } from "src/app/services/init-provider";

@Component({
  selector: 'app-product-quantity-input',
  templateUrl: './product-quantity-input.component.html',
  styleUrls: ['./product-quantity-input.component.css']
})
export class ProductQuantityInputComponent implements OnInit {

  @Output()
  public onAdd = new EventEmitter<number>();
  @Input()
  public product: any;
  @Input()
  public produtoDescrHeight;
  public pedido: any;
  public quantity: number = 0;
  public inputClass: string = ''
  public SITE: any;
  public theme: any;
  public hovered: boolean = false;
  public error: boolean = false;
  public validaEstoque: boolean = true

  constructor(
    public pedidoService: PedidoService,
    public initProvider: InitProvider,
    public toastService: ToastrService
  ) {
    this.pedido = this.pedidoService.pedido;
    this.SITE = Configuracoes.SITE;
    this.theme = Configuracoes.themes.filter((i) => i.id == Configuracoes.SITE.theme)[0];
  }

  ngOnInit(): void {
    if (this.pedidoService.pedido) {
      this.pedido = this.pedidoService.pedido
      this.validaEstoque = this.pedidoService.pedido.tipo.validaEstoque
    }
    // console.log(this.initProvider.inicializaPedido)
    if (this.product.quantidade) {
      this.quantity = this.product.quantidade;
    } else {
      this.quantity = 1;
      this.inputClass = 'disabled';
    }
  }

  public addCart() {
    if (this.product.multiplo && this.quantity % this.product.multiplo > 0) {
      this.error = true;
      this.toastService.warning("Quantidade múltipla de (" + this.product.multiplo + ") incorreta!", "Produto", {
        positionClass: "toast-bottom-left",
      });
      return;
    }

    if (this.product.estoque < this.quantity && this.pedido.tipo.validaEstoque) {
      this.error = true;
      this.toastService.warning("Estoque insuficiente!", "Produto", {
        positionClass: "toast-bottom-left",
      });
      return;
    }

    this.error = false;
    this.onAdd.emit(this.quantity);
  }

  public setQuantity(event) {
    this.quantity = Number(event.target.value);
    this.inputClass = '';
  }

  public plus(multiplo: number) {
    if(multiplo === null){
      multiplo = 1
    }
    if (this.quantity === 0) {
        this.quantity = multiplo;
    } else if (this.quantity % multiplo === 0) {
        this.quantity = this.quantity + multiplo;
    } else {
        this.quantity = Math.ceil(this.quantity / multiplo) * multiplo;
    }
    this.inputClass = '';
}

public less(multiplo: number) {
  if(multiplo === null){
    multiplo = 1
  }
  if (this.quantity === 0) {
      // Não faz nada se quantity já é 0
      return;
  } else if (this.quantity === 1 || this.quantity < multiplo) {
      // Se quantity for 1 ou menor que multiplo, define quantity como 0
      this.quantity = 0;
  } else if (this.quantity % multiplo === 0) {
      // Se quantity for múltiplo de multiplo, decremente por multiplo
      this.quantity = this.quantity - multiplo;
  } else {
      // Se quantity não for múltiplo de multiplo, ajusta para o múltiplo inferior de multiplo
      this.quantity = Math.floor(this.quantity / multiplo) * multiplo;
  }
  this.inputClass = '';
}

  public updateQuantity(quantity) {
    this.product.quantidade = quantity;
    this.ngOnInit();
  }

}